import React, { useState } from "react";
import { Button, Container, Row, Col, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderChatBoat from "./HeaderChatBoat";

function RegularUser() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    return (
        <>
            <HeaderChatBoat />
            <section
                className="content-height"
                style={{ overflowY: "hidden", minHeight: "89vh" }}
            >
                <div className="d-flex flex-column mt-60px" style={{ height: '90vh!important' }}>
                    <Container fluid className="flex-grow-1 p-0">
                        <Row className="h-100 g-0">

                            {/* ---------- Fixed Sidebar ---------- */}
                            <div
                                className="border-end d-flex flex-column p-3 bg-white"
                                style={{
                                    position: "fixed",
                                    top: "60px",
                                    left: 0,
                                    bottom: 0,
                                    width: sidebarOpen ? "350px" : "60px",
                                    transition: "width 0.3s ease",
                                    whiteSpace: "nowrap",
                                    overflowY: "auto",
                                    zIndex: 1000,
                                }}
                            >
                                {sidebarOpen && (
                                    <div className="d-flex flex-column gap-3 p-2">
                                        <div className="row mt-5 sideBarBox">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <button className="btn btn-chat w-100">+ New Chat</button>

                                                <h6 className="mt-3">Recent</h6>

                                                <div className="d-flex justify-content-between align-items-center recentChat mb-2">
                                                    <div>Recent Chat</div>
                                                    <div><img src="/assets/images/more.png" /></div>
                                                </div>
                                                <button className="btn btn-newchat"> New Chat</button>
                                                <h6 className="mt-3">Yesterday</h6>
                                                <div className="d-flex flex-column text-start">
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <Button
                                    size="sm"
                                    onClick={toggleSidebar}
                                    className="position-absolute btn bg-white border-0"
                                    style={{
                                        right: "14px",
                                        borderRadius: "50%",
                                        zIndex: 5,
                                        width: "30px",
                                        height: "30px",
                                        padding: 0,
                                        top: "20px",
                                        boxShadow: "none",
                                    }}
                                    title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
                                >
                                    <img
                                        src="/assets/images/Layout.png"
                                        height={20}
                                        alt="toggle"
                                    />
                                </Button>
                            </div>

                            {/* ---------- Main Chat Area ---------- */}
                            <Col
                                className="d-flex flex-column"
                                style={{
                                    marginLeft: sidebarOpen ? "350px" : "60px",
                                    transition: "margin-left 0.3s ease",
                                }}
                            >
                                <div
                                    className="flex-grow-1 p-3 overflow-auto"
                                    style={{ height: "72vh", overflowY: "scroll" }}
                                >
                                    <div className="row">
                                        <div className="col-sm-12 col-md-2 col-lg-2"></div>
                                        <div className="col-sm-12 col-md-8 col-lg-8">
                                            <div className="pt-3 userText">
                                                <div className="d-flex justify-content-start align-items-start">
                                                    <div>
                                                        <p className="mb-0 pe-2">
                                                            <img
                                                                src="/assets/images/logo-chatboat.png" height={40}
                                                                alt="Logo"
                                                                className=""
                                                            />
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <h4>Hello!</h4>
                                                        <h4>How can I assist you with Advisory today?</h4>
                                                        <p>Choose a prompt below or write your own to start chatting with Advisory</p>
                                                    </div>
                                                </div>

                                                <div className="form-group text-start">
                                                    <button className="btn btn-Quetion mt-1">
                                                       What is the pond Temperature in ___ Camp?
                                                    </button>
                                                    <button className="btn btn-Quetion mt-1">
                                                        What is the air temperature in ___ Camp?
                                                    </button>
                                                    <button className="btn btn-Quetion mt-1">
                                                        What is the advisory for the next week for ____Species in ___ Camp?
                                                    </button>

                                                    <button className="btn btn-Quetion mt-1">
                                                        How many fish farmers are registered in __ Camp? __ District
                                                    </button>

                                                    <button className="btn btn-Quetion mt-1">
                                                        How many Extension Officers are registered in __Camp? District?
                                                    </button>
                                                    <button className="btn btn-Quetion mt-1">
                                                        How many advisories were broadcasted in __ Camp this week?
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-2 col-lg-2"></div>
                                    </div>
                                </div>

                                <div className="bg-white mx-100px">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <input
                                                type="text"
                                                className="form-control bg-white h42px border-0"
                                                placeholder="Ask me a questions..."
                                            />
                                        </div>
                                        <div className="card-footer bg-white p-0">
                                            <div className="d-flex justify-content-between align-items-center p-1">
                                                <div>
                                                    <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/message.png" /></span> Browse Prompts</button>
                                                    <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/attach.png" /></span> Attach</button>
                                                    <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/setting.png" /></span> Settings</button>
                                                </div>
                                                <div>
                                                    <button className="btn btnActionButton p-0"><span className=""><img src="/assets/images/send.png" /></span></button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <p className="mb-0 textError">Chatbot can make mistakes sometimes, please double check</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default RegularUser;
